<template>
  <b-dropdown-item @click="$emit('change-access')">
    <img v-if="visitor ? visitor.access : transport.access"
        class="icon-pdf"
        :src="require('@/common/assets/img/icons/menuVisitor/v_accept.svg')"
        alt="Разрешить доступ"/>
    <img v-else
        :src="require('@/common/assets/img/icons/menuVisitor/v_denied.svg')"
        class="icon-pdf"
        alt="Запретить доступ"/>
    {{ (visitor ? visitor.access : transport.access) ? 'Разрешить доступ' : 'Запретить доступ' }}
  </b-dropdown-item>
</template>

<script>
export default {
  props: {
    visitor: {
      type: Object
    },

    transport: {
      type: Object
    }
  }
}
</script>
